import React from 'react';
import { Box, TextField, Autocomplete } from '@mui/material';
import { COUNTRIES } from '../utils/countries';

const flagEmoji = (iso) =>
  iso ? String.fromCodePoint(...iso.toUpperCase().split('').map((c) => 127397 + c.charCodeAt(0))) : '';

const PhoneCountryPicker = ({
  countryCc = '91',
  onChangeCc,
  value = '',
  onChange,
  numberLabel = 'Phone Number',
  numberPlaceholder = 'e.g. 9876543210',
  helperText = '',
  error = false,
  disabled = false,
}) => {
  const current = COUNTRIES.find((c) => c.cc === countryCc) || COUNTRIES[0];

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 2 }}>
      <Autocomplete
        disabled={disabled}
        options={COUNTRIES}
        getOptionLabel={(opt) => `+${opt.cc}`}
        isOptionEqualToValue={(opt, val) => opt.iso === val.iso}
        value={current}
        onChange={(e, opt) => onChangeCc(opt?.cc || '91')}
        renderOption={(props, opt) => (
          <Box component="li" {...props} sx={{ display: 'flex', gap: 1, fontSize: 14 }}>
            <span>{flagEmoji(opt.iso)}</span>
            <span>{opt.name}</span>
            <span style={{ marginLeft: 'auto', color: '#64748b' }}>+{opt.cc}</span>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Country"
            placeholder="Search country"
            sx={{
              width: 120,
              '& .MuiOutlinedInput-root': { borderRadius: '14px', bgcolor: '#f8fafc' },
              '& .MuiInputLabel-root': { fontWeight: 500 },
            }}
          />
        )}
        disableClearable
      />
      <TextField
        disabled={disabled}
        label={numberLabel}
        fullWidth
        required
        type="tel"
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/[^0-9]/g, ''))}
        placeholder={numberPlaceholder}
        helperText={helperText}
        InputProps={{ sx: { borderRadius: '14px', bgcolor: '#f8fafc', fontSize: 18, fontWeight: 700, letterSpacing: 1 } }}
        InputLabelProps={{ sx: { fontWeight: 500 } }}
      />
    </Box>
  );
};

export default PhoneCountryPicker;
